import { Entity } from './types'

const headerCells = {
  [Entity.Count]: '№ п/п',
  [Entity.Category]: 'Категория обучающихся',
  [Entity.Students]: 'Количество обучающихся в месяц в отношении которых оказаны услуги',
  [Entity.Compensation]: 'Размер возмещения стоимости питания за одного обучающегося в день обучения',
  [Entity.TotalRow]: 'Размер платежа субсидий (руб)',
}

export const createHeaderCells = () => {
  return { ...headerCells }
}
